import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subscription } from 'rxjs';

import { AuthService } from '../shared/services/auth/auth.service';
import { FeedbackService } from '../shared/services/feedback/feedback.service';
import { ProtocolDroidService } from '../shared/services/protocol-droid/services/protocol-droid.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  @ViewChild('password', { static: true }) passwordRef: ElementRef;
  longSession = new FormControl();
  credentials: any;
  redirection: string;
  customMessage: string;
  emailInput: string;
  signInError: string;

  private subscriptions: Subscription[];
  private focusSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private protocolDroidService: ProtocolDroidService,
    private feedbackService: FeedbackService
  ) {
    this.subscriptions = [];
    this.longSession = new FormControl();
  }

  // Automatic check of the current session state each time the user focus again on this page
  @HostListener('window:focus')
  onFocus() {
    this.focusSub?.unsubscribe();
    this.focusSub = this.authService.checkSession().subscribe(res => {
      // If the user reconnected from another tab, we don't want him to stay blocked on this page
      if (res.isConnected && res.isSessionActive) this.authService.redirectUserAfterLogin(this.redirection);
    });
  }

  get isPasswordHide(): boolean {
    return this.passwordRef?.nativeElement?.type === 'password';
  }

  ngOnInit() {
    setTimeout(() => {
      this.feedbackService.hideSpinner();
    }, 1000);
    this.subscriptions.push(
      this.route.queryParamMap.subscribe((params: ParamMap) => {
        this.redirection = params.get('rd') as string;
        this.customMessage = params.get('message') as string;
        this.emailInput = params.get('email') as string;
      })
    );
  }

  ngOnDestroy() {
    this.focusSub?.unsubscribe();
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  loginWithCredentials(event: any, email: string, password: string): void {
    // Necessary to stop events from ENTER key
    event.stopPropagation();
    event.preventDefault();
    this.signInError = null;
    this.authService
      .loginWithCredentials({ email, password })
      .then(res => this.authService.handleUserArrival(res?.user, { longSession: this.longSession.value, redir: this.redirection }))
      .catch(() => {
        this.signInError = this.protocolDroidService.translate('login.invalid-credentials');
      });
  }

  googleAuth(): void {
    this.authService
      .signinWithGoogle()
      .then(res => this.authService.handleUserArrival(res?.user, { longSession: this.longSession.value, redir: this.redirection }));
  }

  microsoftAuth(): void {
    this.authService
      .signinWithMicrosoft()
      .then(res => this.authService.handleUserArrival(res?.user, { longSession: this.longSession.value, redir: this.redirection }));
  }

  handleSignInError(): boolean {
    if (this.signInError) {
      return true;
    } else return false;
  }

  setTypeInputPassword(): void {
    const typePassword = this.passwordRef?.nativeElement?.type;
    if (typePassword) {
      this.passwordRef.nativeElement.type = typePassword === 'password' ? 'text' : 'password';
    }
  }
}
